export class CommentDialogResult {
	public comment: string;
	public result: boolean;
}
